import { defineComponent as _defineComponent } from 'vue'
import {
  getPreviewRedemptionProducts,
  IPreviewRedemptionProducts
} from '@/modules/wealth/services/wealth-about';
import {
  BaseText,
  HeadingDisplay,
  HelperViewStatus,
  SpinnerLoader
} from '@warrenbrasil/nebraska-web';
import { onMounted, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AboutRedemption',
  props: {
    portfolioId: null
  },
  setup(__props: any) {

const props = __props as { portfolioId: string };

const isLoading = ref(true);
const hasError = ref(false);
const redemptionProducts = ref<IPreviewRedemptionProducts[]>();



async function fetchPreviewRedemptionProducts() {
  isLoading.value = true;
  hasError.value = false;

  try {
    const response = await getPreviewRedemptionProducts(props.portfolioId);
    redemptionProducts.value = response;
  } catch (error) {
    hasError.value = true;
  } finally {
    isLoading.value = false;
  }
}

const handleHelperClick = () => {
  fetchPreviewRedemptionProducts();
};

onMounted(() => {
  fetchPreviewRedemptionProducts();
});

return { __sfc: true,isLoading, hasError, redemptionProducts, props, fetchPreviewRedemptionProducts, handleHelperClick, BaseText, HeadingDisplay, HelperViewStatus, SpinnerLoader }
}

})